import { useParams } from "react-router-dom";
import { usePageTitle } from "@/hooks/usePageTitle";
import { QueryDetailPage } from "@/components/queries";
import { useSavedQuery } from "@/hooks/savedQueries";

const QueryDetail = () => {
	const { id } = useParams<{ id: string }>();
	const isNew = id === 'new';
	const { data: savedQuery } = useSavedQuery(isNew ? undefined : id);

	usePageTitle(savedQuery ? savedQuery.name : isNew ? "New Query" : "Query");
	return <QueryDetailPage />;
};

export default QueryDetail;
